//
//
//
//
//
//
//
//
//
//

export default {
  name: "EmptyLayout",
  head: () => ({
    title: ""
  }),
}
